var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.496,
    height: 47.493,
    viewBox: "0 0 47.496 47.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{stroke:#000;stroke-width:.4px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card_1_",
    "data-name": "credit-card (1)",
    transform: "translate(.2 .189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0 .011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M45.845 16.172L30.932 1.259a4.285 4.285 0 0 0-6.046 0L1.248 24.9a4.284 4.284 0 0 0 0 6.046l1.839 1.839 12.36 12.357h-1.711a.981.981 0 0 0 0 1.962h19.622a.981.981 0 0 0 0-1.962H22.921l22.924-22.924a4.28 4.28 0 0 0 0-6.046zm-1.387 4.658L20.82 44.469a2.3 2.3 0 0 1-1.632.673h-.008a2.3 2.3 0 0 1-1.631-.673l-12.38-12.38 22.7-22.7A.981.981 0 1 0 26.482 8L3.781 30.7l-1.145-1.144a2.323 2.323 0 0 1 0-3.271L26.274 2.647a2.323 2.323 0 0 1 3.271 0l5.308 5.308-22.7 22.7a.981.981 0 1 0 1.387 1.387l22.7-22.7 8.218 8.217a2.316 2.316 0 0 1 0 3.271z",
    className: "cls-1",
    "data-name": "Path 30",
    transform: "translate(0 -.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M170.054 305.228a.981.981 0 0 0-1.388 0l-7.721 7.72a.981.981 0 0 0 1.387 1.388l7.721-7.72a.981.981 0 0 0 .001-1.388z",
    className: "cls-1",
    "data-name": "Path 31",
    transform: "translate(-145.88 -276.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M194.28 384.9l-3.167 3.167a.981.981 0 1 0 1.387 1.388l3.167-3.167a.981.981 0 0 0-1.387-1.388z",
    className: "cls-1",
    "data-name": "Path 32",
    transform: "translate(-173.273 -349.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M253.108 353.229l-.416.416a.981.981 0 1 0 1.387 1.388l.416-.416a.981.981 0 0 0-1.387-1.388z",
    className: "cls-1",
    "data-name": "Path 33",
    transform: "translate(-229.187 -320.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M349.448 160.956a.981.981 0 0 0-1.387 0l-4.163 4.163a.981.981 0 0 0 0 1.387l2.775 2.775a.981.981 0 0 0 1.388 0l4.163-4.162a.981.981 0 0 0 0-1.387zm-2.081 6.244l-1.388-1.387 2.775-2.775 1.387 1.388z",
    className: "cls-1",
    "data-name": "Path 34",
    transform: "translate(-312.004 -145.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M310.654 56.705a.978.978 0 0 0 .694-.288l.416-.416a.981.981 0 0 0-1.388-1.387l-.416.416a.981.981 0 0 0 .694 1.675z",
    className: "cls-1",
    "data-name": "Path 35",
    transform: "translate(-281.188 -49.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M100.27 355.22l-.416.416a.981.981 0 0 0 1.387 1.388l.416-.416a.981.981 0 1 0-1.387-1.388z",
    className: "cls-1",
    "data-name": "Path 36",
    transform: "translate(-90.408 -322.286)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card .49aa7dc0.svg";
export { ForwardRef as ReactComponent };